import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../state/state.types';

const mapState = ({ queryParams, results }: StateType) => ({
  type: queryParams.type,
  searchLoading: results.searchLoading,
  paginationLoading: results.paginationLoading,
  loaded: results.loaded,
  totalHits: results.totalHits,
  hasResults: results.totalHits > 0,
  endOfResults: results.theEnd && !results.error && !results.resultsWasCut,
  error: results.error,
  searchTime: results.searchTime,
  sortType: queryParams.sort,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
